module.exports = __webpack_public_path__ + "static/media/Gift_Card.42eaca0c.png";